import React from 'react';
import { Select, Input, Button, Form, Skeleton } from 'antd';
import { injectIntl, FormattedMessage } from 'react-intl';
import styles from './AvailableCredit.module.scss';
import messages from '../../Containers/ManualSearchV2/ManualSearchMessages';

const { Option } = Select;

const AvailableCredit = props => {
  const {
    fetchAvailableCreditsApiStatus,
    displayAmount,
    getShouldHideAddCreditsForm,
    handleSendRequest,
    requestForCreditsApiStatus,
    isSendRequestButtonDisabled,
    validateCredits,
    form,
    creditName,
    creditType,
    intl
  } = props;

   const getDisclaimerMessageForCreditType = creditType => {
    const messageForArya = <FormattedMessage {...messages.accessToTheContactInformationLabel} />;
    const messageForSMS = <FormattedMessage {...messages.accessToAryasTextingFeatureLabel} />;
    return creditType === 'Arya' ? messageForArya : messageForSMS;
  };

  const CreditName= creditName.replace(/\s+/g, '');

  return (
    <div className={styles.creditsSettings}>
      <div className={styles.creditsDisplay}>
        <div className={styles.creditsDisplayTitle}><FormattedMessage {...messages[CreditName]} /></div>
        <div className={styles.creditsDisplayAmount}>
          <Skeleton
            active
            title={false}
            paragraph={{ rows: 1, width: '64px' }}
            loading={
              fetchAvailableCreditsApiStatus?.type === creditType &&
              fetchAvailableCreditsApiStatus.status === 'INPROGRESS'
            }
          >
            {displayAmount}
          </Skeleton>
        </div>
      </div>
      <div className={`${getShouldHideAddCreditsForm(creditType) ? styles.hideCreditsForm : ''}`}>
        <div className={styles.creditsRequest}>
          <Form.Item label={<FormattedMessage {...messages.requestMoreCreditsLabel} />} colon={false} required={false}>
            {form.getFieldDecorator('Credits', {
              rules: [{ required: true, message: 'Please choose credits' }],
            })(
              <Select className={styles.creditsRequestAmount}>
                <Option value={500}>500</Option>
                <Option value={1000}>1000</Option>
                <Option value={2000}>2000</Option>
                <Option value="Customize"><FormattedMessage {...messages.customizeLabel} /></Option>
              </Select>
            )}
          </Form.Item>
        </div>

        {form.getFieldValue('Credits') === 'Customize' ? (
          <div className={styles.otherAmountRequest}>
            <Form.Item label={intl.formatMessage({ ...messages.enterOtherAmountLabel })} colon={false}>
              {form.getFieldDecorator('OtherAmount', {
                rules: [{ validator: validateCredits }],
              })(<Input className={styles.otherAmountInput} placeholder={intl.formatMessage({ ...messages.enterCreditAmountsLabel })} />)}
            </Form.Item>
          </div>
        ) : null}
        <Button
          className={styles.sendRequestButton}
          onClick={e => {
            handleSendRequest(e, creditType, form);
          }}
          loading={
            requestForCreditsApiStatus?.type === creditType && requestForCreditsApiStatus?.status === 'INPROGRESS'
          }
          disabled={isSendRequestButtonDisabled(form)}
        >
          <FormattedMessage {...messages.sendRequestLabel} />
        </Button>
      </div>
      <div className={styles.creditsSubmitDisclaimer}>{getDisclaimerMessageForCreditType(creditType)}</div>
    </div>
  );
};


export default (injectIntl(Form.create()(AvailableCredit)));
export { AvailableCredit as AvailableCreditWithoutForm };
